import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { isDefined } from 'angular';
import { Attachment } from '../types/attachment';
import { MicroChart } from '../../types/rfp-offer-savings/microchart';

@Injectable({
  providedIn: 'root',
})
export class OfferApiService {
  getBaseUrl(offerId: number): string {
    return `/aptitude/api/offers/${offerId}`;
  }

  constructor(private http: HttpClient) {}

  getOfferAttachments(offerId: number): Observable<Array<Attachment>> {
    return this.http.get<Array<Attachment>>(
      `${this.getBaseUrl(offerId)}/documents`,
    );
  }

  /**
   * Get the microchart data for an offer
   *
   * @param  {number}                  offerId                   The offerId
   * @param  {number}                  partnerId                 Only necessary for partner viewing a group rfp
   * @param  {boolean}                 usePrimaryCrossReferences [description]
   * @return {Observable<MicroChart>}                            [description]
   */
  getMicrochart(
    offerId: number,
    partnerId?: number,
    usePrimaryCrossReferences?: boolean,
  ): Observable<MicroChart> {
    let params: HttpParams = new HttpParams();

    // HttpParams are immutable, we have to take the output of the set functions to get all the changes.
    if (isDefined(usePrimaryCrossReferences)) {
      params = params.set(
        'usePrimaryCrossReferences',
        Boolean(usePrimaryCrossReferences).toString(),
      );
    }
    if (partnerId) {
      params = params.set('partnerId', partnerId.toString());
    }

    return this.http.get<MicroChart>(`${this.getBaseUrl(offerId)}/microchart`, {
      params,
    });
  }
}
